import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";
import { CITIES } from "@/lib/cities";
import areasHero from "@/assets/areas-hero.webp";

export const Route = createFileRoute("/areas-served/")({
  head: () => ({
    meta: [
      { title: "Areas Served | Phoenix Plumbing Co. Service Area" },
      { name: "description", content: "Phoenix Plumbing Co. serves Phoenix, Scottsdale, Glendale, Tempe, Mesa, Chandler, Gilbert and the entire Valley. Call 602-834-1208." },
      { property: "og:title", content: "Areas Served | Phoenix Plumbing Co. Service Area" },
      { property: "og:description", content: "Phoenix Plumbing Co. serves Phoenix, Scottsdale, Glendale, Tempe, Mesa, Chandler, Gilbert and the entire Valley. Call 602-834-1208." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/areas-served" },
      { name: "twitter:title", content: "Areas Served | Phoenix Plumbing Co. Service Area" },
      { name: "twitter:description", content: "Phoenix Plumbing Co. serves Phoenix, Scottsdale, Glendale, Tempe, Mesa, Chandler, Gilbert and the entire Valley. Call 602-834-1208." },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/areas-served" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="relative bg-secondary text-secondary-foreground overflow-hidden">
        <div aria-hidden className="absolute inset-0 opacity-40 bg-cover bg-center" style={{ backgroundImage: `url(${areasHero})` }} />
        <div aria-hidden className="absolute inset-0 bg-gradient-to-r from-secondary via-secondary/80 to-secondary/50" />
        <div className="relative mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Areas Served</h1>
          <p className="mt-4 text-secondary-foreground/90 text-lg">Phoenix Plumbing Co. serves Phoenix, Scottsdale, Glendale, Tempe, Mesa, Chandler, Gilbert and the entire Valley. Call 602-834-1208.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-12">
        <h2 className="text-2xl md:text-3xl font-extrabold text-secondary">Cities We Serve Across the Valley</h2>
        <p className="mt-3 max-w-3xl text-foreground">
          Phoenix Plumbing Co. dispatches licensed plumbers across the entire Phoenix metro. Tap your city for local
          response times, neighborhood coverage, and the plumbing issues we see most often there.
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CITIES.map((c) => (
            <Link
              key={c.slug}
              to="/areas-served/$city"
              params={{ city: c.slug }}
              className="group rounded-xl border border-border bg-card p-5 hover:border-primary hover:shadow-md transition-all"
            >
              <div className="font-extrabold text-secondary text-lg group-hover:text-primary">
                Plumber in {c.name}, AZ
              </div>
              <p className="mt-1 text-sm text-muted-foreground">{c.blurb}</p>
              <div className="mt-3 text-xs font-semibold text-primary">
                {c.responseTime} response →
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CTABand />
    </>
  );
}
